(function () {
  if (window.kwoBulkNoteLoaded) return;
  window.kwoBulkNoteLoaded = true;

  var tries = 0;

  function maxKg(bundleEl) {
    var sr = bundleEl.shadowRoot;
    if (!sr) return 0;
    var max = 0;
    sr.querySelectorAll('.title').forEach(function (t) {
      var m = t.textContent.trim().match(/^(\d+(?:[.,]\d+)?)\s*kg$/i);
      if (!m) return;
      var v = parseFloat(m[1].replace(',', '.'));
      if (v > max) max = v;
    });
    return max;
  }

  function place() {
    var src = document.querySelector('.kwo-bulk-src');
    var bundleEl = document.querySelector('section-store--bundle-block');
    if (!src || !bundleEl) return false;
    var ids = bundleEl.getAttribute('data-short-ids');
    if (!ids || !ids.trim()) return true;
    var host = bundleEl.closest('.product-form-block');
    if (!host) return true;

    var kg = maxKg(bundleEl);
    if (!kg && tries < 40) return false;

    document.querySelectorAll('[data-kwo-bulk]:not(.kwo-bulk-src *)').forEach(function (n) { n.remove(); });

    var note = src.querySelector('[data-kwo-bulk="note"]');
    var card = src.querySelector('[data-kwo-bulk="card"]');
    var noteBelow = src.getAttribute('data-note-position') === 'below';
    var kgLabel = String(kg).replace('.', ',');

    if (card && kg) {
      var title = card.querySelector('.kwo-bulk-title');
      if (title) title.textContent = title.textContent.replace('{kg}', kgLabel);
      host.after(card);
    } else if (card) {
      card.remove();
    }
    if (note) {
      if (noteBelow && card && card.isConnected) card.after(note);
      else if (noteBelow) host.after(note);
      else (document.querySelector('.kwo-mix') || host).before(note);
    }
    return true;
  }

  function start() {
    tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (place() || tries > 41) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();